import { createIcon } from '../icon'
import RattingColorIcon from '@/components/atoms/svg/RattingColorIcon'

export const RattingColorIconDefault = createIcon(RattingColorIcon)
